// extracted by mini-css-extract-plugin
export default {"redirectDiv":"RedirectUrl_redirectDiv__ERRQC","redirectLogo":"RedirectUrl_redirectLogo__fH0MS"};